/**
 * Pairs Best With JavaScript
 * Handles only the open/close functionality for the recommendation block
 */
class PairsBestWith {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Toggle button functionality
    document.addEventListener('click', (e) => {
      if (e.target.matches('.f-pairs-best-with__toggle')) {
        this.toggleRecommendation(e.target);
      }
      
      if (e.target.matches('.f-pairs-best-with__close')) {
        console.log('Close button clicked!'); // Debug
        this.closeRecommendation(e.target);
      }
      
      // Add to cart functionality
      if (e.target.matches('.f-pairs-best-with__add, .f-pairs-best-with__add-mini')) {
        this.addToCart(e.target);
      }
    });
  }

  toggleRecommendation(toggleButton) {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    const contentId = toggleButton.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    
    if (isExpanded) {
      // Collapse
      toggleButton.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.display = 'none';
    } else {
      // Expand
      toggleButton.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.style.display = 'block';
    }
  }

  closeRecommendation(closeButton) {
    const pairsContainer = closeButton.closest('.f-pairs-best-with');
    const toggleButton = pairsContainer.querySelector('.f-pairs-best-with__toggle');
    const content = pairsContainer.querySelector('.f-pairs-best-with__content');
    
    toggleButton.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.display = 'none';
  }

  async addToCart(button) {
    const productId = button.dataset.productId;
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;
    
    if (!productId || !variantId) {
      console.error('Missing product or variant ID for add to cart');
      return;
    }

    // Store original text outside try block so it's available in catch
    const originalText = button.textContent;
    
    try {
      // Show loading state
      button.textContent = 'Adding...';
      button.disabled = true;

      // Add to cart using the same pattern as theme's cart recommendations
      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      // Get cart drawer sections to update (exactly like working cart-recommendations.js)
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      const response = await fetch(`${window.FoxThemeSettings.routes.cart_add_url}`, config);
      
      if (!response.ok) {
        throw new Error('Failed to add product to cart');
      }
      
      const responseData = await response.json();
      
      if (responseData.status) {
        throw new Error(responseData.description || 'Failed to add product to cart');
      }

      // Success! Use the theme's proper cart update with sections data (exactly like cart recommendations)
      if (window.FoxThemeEvents && window.FoxThemeEvents.emit) {
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, responseData);
      }
      
      // Reset button state
      button.textContent = originalText;
      button.disabled = false;
      
    } catch (error) {
      console.error('Error adding product to cart:', error);
      
      // Reset button state
      button.textContent = originalText;
      button.disabled = false;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new PairsBestWith();
});

// Export for use in other modules
window.PairsBestWith = PairsBestWith;

